import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import Colorway from './Colorway';
import ColorwayBadge from '../ColorwayBadge';
import css from './ProductListItem.module.scss';
import storefrontClient from '../../utils/storefrontClient';
import Price, { displayCAP } from '../Price';
import WishListCache from '../../apps/customers/WishListCache';
import WishListItemToggle from '../../apps/pages/wish-lists/WishListItemToggle';
import toGlobalID from '../../utils/toGlobalID';
import formatPrice from '../../utils/strings/formatPrice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Product = function Product(_ref) {
  var children = _ref.children,
      colorNode = _ref.colorNode,
      colorway = _ref.colorway,
      displayEditorial = _ref.displayEditorial,
      displayPrice = _ref.displayPrice,
      displayWishListToggle = _ref.displayWishListToggle,
      handle = _ref.handle,
      isMobile = _ref.isMobile,
      lazyload = _ref.lazyload,
      onPLP = _ref.onPLP,
      product = _ref.product,
      token = _ref.token,
      url = _ref.url;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      availability = _useState2[0],
      setAvailability = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showHeart = _useState4[0],
      setShowHeart = _useState4[1];

  var _useInView = useInView({
    rootMargin: '5% 0px 10% 0px',
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var badge = colorway.badge || {};
  var image = colorway.image,
      variant = colorway.variant;
  var compareAtPrice = variant.compareAtPrice,
      price = variant.price,
      shopifyId = variant.shopifyId;
  var urlWithVariant = "".concat(url, "?variant=").concat(shopifyId).concat(token ? "&rtoken=".concat(token) : '');
  useEffect(function () {
    if (availability !== false || !inView) {
      return;
    }

    var load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var newAvailability, inventoryQuery, queries, query, _yield$storefrontClie, data, _query, _yield$storefrontClie2, _data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newAvailability = {};
                inventoryQuery = '{ variants(first: 200) { edges { node { id availableForSale } } } }';

                if (!product.split) {
                  _context.next = 14;
                  break;
                }

                queries = [];
                product.colorways.edges.forEach(function (_ref3) {
                  var node = _ref3.node;
                  var colorwayId = "product".concat(toGlobalID(node.id));
                  queries.push("".concat(colorwayId, ": product(handle: \"").concat(node.handle, "\") ").concat(inventoryQuery));
                });
                query = "{ ".concat(queries.join(''), " }");
                _context.next = 8;
                return storefrontClient(query);

              case 8:
                _yield$storefrontClie = _context.sent;
                data = _yield$storefrontClie.data;
                product.colorways.edges.forEach(function (_ref4) {
                  var _data$colorwayId;

                  var node = _ref4.node;
                  var colorwayId = "product".concat(toGlobalID(node.id));
                  var variants = ((_data$colorwayId = data[colorwayId]) === null || _data$colorwayId === void 0 ? void 0 : _data$colorwayId.variants.edges) || [];
                  variants.forEach(function (_ref5) {
                    var _ref5$node = _ref5.node,
                        id = _ref5$node.id,
                        availableForSale = _ref5$node.availableForSale;
                    var parts = id.split('/');
                    newAvailability[parts[parts.length - 1]] = availableForSale;
                  });
                });
                setAvailability(newAvailability);
                _context.next = 25;
                break;

              case 14:
                _query = "{ product(handle: \"".concat(handle, "\") ").concat(inventoryQuery, " }");
                _context.next = 17;
                return storefrontClient(_query);

              case 17:
                _yield$storefrontClie2 = _context.sent;
                _data = _yield$storefrontClie2.data;

                if (_data.product) {
                  _context.next = 23;
                  break;
                }

                console.error('Failed to load', handle);
                setAvailability(true);
                return _context.abrupt("return");

              case 23:
                _data.product.variants.edges.forEach(function (_ref6) {
                  var _ref6$node = _ref6.node,
                      id = _ref6$node.id,
                      availableForSale = _ref6$node.availableForSale;
                  var parts = id.split('/');
                  newAvailability[parts[parts.length - 1]] = availableForSale;
                });

                setAvailability(newAvailability);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();

    load();
  }, [availability, inView, handle, product]); // Check if product is on the customers wishlist

  var cachedWishListItem = false;

  if (displayWishListToggle) {
    var cache = new WishListCache().get();

    if (cache && cache.colorways[colorway.id]) {
      cachedWishListItem = true;
    }
  } // Generate aria label


  var showCAP = compareAtPrice && displayCAP(compareAtPrice, price);
  var subtitle = product.properties.collectionSubtitle ? " ".concat(product.properties.collectionSubtitle, ". ") : '';
  var capLabel = showCAP ? " Original price ".concat(formatPrice(compareAtPrice), ".") : '';
  var titleLabel = "Click to view ".concat(product.title, ".").concat(subtitle);
  var priceLabel = "Price ".concat(formatPrice(price), ".").concat(capLabel);
  var ariaLabel = "".concat(titleLabel, " ").concat(priceLabel);
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.colorway,
      ref: ref,
      children: [/*#__PURE__*/_jsx(ColorwayBadge, _objectSpread(_objectSpread({}, badge), {}, {
        compareAtPrice: compareAtPrice,
        price: price
      })), /*#__PURE__*/_jsx(Colorway, {
        availability: availability,
        display: inView,
        id: colorway.id,
        isMobile: isMobile,
        displayEditorial: displayEditorial,
        lazyload: lazyload,
        image: image,
        product: product,
        title: "".concat(product.properties.genderDisplay).concat(product.properties.genderDisplay === 'Unisex' ? '' : "'s", " ").concat(product.title, " in the Color ").concat(colorway.color),
        url: urlWithVariant
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.titleWrap,
      children: [children, /*#__PURE__*/_jsx("div", {
        className: css.title,
        children: /*#__PURE__*/_jsxs("a", {
          href: urlWithVariant,
          "aria-label": ariaLabel,
          children: [/*#__PURE__*/_jsx("div", {
            "aria-hidden": true,
            className: css.linkTitle,
            children: product.title
          }), product.properties.collectionSubtitle && /*#__PURE__*/_jsx("div", {
            "aria-hidden": true,
            className: css.subtitle,
            children: product.properties.collectionSubtitle
          }), displayPrice && /*#__PURE__*/_jsx("div", {
            "aria-hidden": true,
            children: /*#__PURE__*/_jsx(Price, {
              className: css.price,
              compareAtPrice: variant.compareAtPrice,
              lowHigh: true,
              price: variant.price
            })
          })]
        })
      }), colorNode, displayWishListToggle && /*#__PURE__*/_jsx("div", {
        className: cc([css.wishListToggle, _defineProperty({}, css.visible, showHeart || cachedWishListItem)]),
        children: /*#__PURE__*/_jsx(WishListItemToggle, {
          initialFilledIn: cachedWishListItem,
          setShowHeart: setShowHeart,
          productId: product.id,
          productTitle: product.title,
          colorwayId: colorway.id,
          colorwayColor: colorway.color,
          listItem: true,
          onPLP: onPLP
        }, colorway.id)
      })]
    })]
  });
};

Product.defaultProps = {
  displayPrice: true,
  displayEditorial: false
};
Product.propTypes = {
  children: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]).isRequired,
  colorNode: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]).isRequired,
  colorway: PropTypes.shape({
    available: PropTypes.bool,
    badge: PropTypes.shape(),
    color: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.shape().isRequired,
    variant: PropTypes.shape({
      price: PropTypes.number,
      compareAtPrice: PropTypes.number,
      shopifyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }).isRequired
  }).isRequired,
  displayEditorial: PropTypes.bool,
  displayPrice: PropTypes.bool,
  displayWishListToggle: PropTypes.bool,
  handle: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onPLP: PropTypes.bool,
  lazyload: PropTypes.bool,
  product: PropTypes.shape({
    properties: PropTypes.shape({
      collectionSubtitle: PropTypes.string,
      description: PropTypes.string,
      genderDisplay: PropTypes.string
    }),
    colorways: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        node: PropTypes.shape({})
      }))
    }),
    id: PropTypes.string,
    split: PropTypes.bool,
    title: PropTypes.string
  }).isRequired,
  token: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  url: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(Product);